export default function ProjectLangTag({tag}) {
    const tags = {
        "fr-FR": "FR",
        "en-US": "EN",
        "de-DE": "DE",
        "it-IT": "IT",
        "nl-NL": "NL",
        "pt-PT": "PT",
        "pt-BR": "BR",
        "es-ES": "ES",
    }
    return (
        <>
        <span className={`project-lang-tag ${tag}`}>{tags[tag]}</span>
        </>
    )
}